import React, { FC } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";

interface ExpandedRequiredDocumentsProps {
  reqDocs: string[];
}

const useStyles = makeStyles(() => ({
  reqDoc: {
    fontSize: 12,
    "& + &": {
      marginTop: 10,
    },
  },
}));

export const ExpandedRequiredDocuments: FC<ExpandedRequiredDocumentsProps> = ({
  reqDocs,
}) => {
  const classes = useStyles();

  return (
    <div>
      {reqDocs.map((recDoc) => (
        <div key={recDoc} className={classes.reqDoc}>
          {recDoc}
        </div>
      ))}
    </div>
  );
};
